import React from 'react'
import clsx from 'clsx'

const Input = ({ 
  label, 
  error, 
  className,
  ...props 
}) => {
  return (
    <div className="space-y-1">
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
          {label}
        </label>
      )}
      <input
        className={clsx(
          'w-full px-3 py-2 border rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent',
          error
            ? 'border-red-300 text-red-900 placeholder-red-300 focus:ring-red-500'
            : 'border-gray-300 dark:border-gray-600 dark:bg-gray-800 dark:text-white',
          className
        )}
        {...props}
      />
      {error && (
        <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
      )}
    </div>
  )
}

export default Input